import { CButton, CCard, CCardBody, CCol, CForm, CInputGroup, CRow } from '@coreui/react'
import React, { useEffect, useRef, useState } from 'react'
import BaseListing from 'src/BaseListings'
import { wtApiCall } from '../../helpers/commons/ApiWrapper'
import { lzNotifyErrorMessageFromResult } from '../../helpers/commons/notifications'
import jsPDF from 'jspdf'
import 'jspdf-autotable'
import moment from 'moment'
import DataTable from './DataTable'
import WidgetVehicleSelector from 'src/widgets/Selectors/WidgetVehicleSelector'
import Loading from 'src/helpers/commons/loader'
import WidgetSelector from 'src/widgets/Selectors/WidgetSelector'
import { useDownloadExcel } from 'react-export-table-to-excel'
import { YesNoOptions } from 'src/helpers/commons/dropdownOptions'
import AttendanceReportLegends from 'src/widgets/Legends/AttendanceReportLegends'
import { wtRoundNumberToSpecifedDigits } from 'src/helpers/commons/utils'
import WidgetDepartmentSelector from '../../widgets/Selectors/WidgetDepartmentSelector'
import { DatePicker } from 'antd';
import Column from 'antd/es/table/Column'
import WidgetDesignationSelector from 'src/widgets/Selectors/WidgetDesignationSelector'
const { RangePicker } = DatePicker;
export default function OvertimeReport() {
  const Base = new BaseListing()
  const tableRef = useRef(null)
  const [isLoading, setIsLoading] = useState(false)
  const [errors, setErrors] = useState([])
  const [reportData, setReportData] = useState([])
  const [FromDate, setFromDate] = useState('')
  const [ToDate, setToDate] = useState('')
  const [Vehicles, setVehicles] = useState([])
  const [VehicleId, setVehicleId] = useState(0)
  const [VehicleName, setVehicleName] = useState('')
  const [leaveTypeData, setLeaveTypeData] = useState([])
  const [departments, setDepartments] = useState([])
  const [department_id, setDepartmentId] = useState(0)
  const [department_name, setDepartmentName] = useState('')
  const [designations, setDesignations] = useState([])
  const [designation_id, setDesignationId] = useState(0)
  const [designation_name, setDesignationName] = useState('')

  const [range, setRange] = useState(null);
  const [reportDataMonths, setReportDataMonths] = useState([])

  const generatePDF = () => {
    const doc = new jsPDF('landscape')
    const logo = 'assets/wil-icon.png'
    const img = new Image()
    var totalPagesExp = "{total_pages_count_string}";
    let yPosition = 45

    const headRows = [
      {
        content: 'Sr',
      },
      // {
      //   dataKey: 'branch.name',
      //   content: 'Branch',
      // },
      {
        dataKey: 'full_name',
        content: 'Full Name',
      },
      {
        dataKey: 'designation.name',
        content: 'Designation',
      },
      {
        dataKey: 'department.name',
        content: 'Department',
      },
      ...reportDataMonths.map((employees, index) => ({
        dataKey: 'evaluation_month',
        content: employees.evaluation_months,
      })),
      {
        dataKey: 'total',
        content: 'Total',
      },
      {
        dataKey: 'percenatage',
        content: 'Percentage',
      },
    ];
    const employeeDetails = reportData.map((employee, index) => {
      const totalRating = employee.evaluations.reduce((acc, evaluation) => acc + (evaluation.rating || 0), 0);
      const totalMaxRating = employee.evaluations.reduce((acc, evaluation) => acc + (evaluation.max_rating || 0), 0);
      const ratingPercentage = totalMaxRating !== 0 ? ((totalRating / totalMaxRating) * 100).toFixed(2) : '-';
    
      return [
        index + 1,
        { content: employee.name, styles: { textColor: '#0000FF', halign: 'left' } },
        { content: employee.designation.name, styles: { halign: 'left' } },
        { content: employee.department.name, styles: { halign: 'left' } },
        ...employee.evaluations.map((evaluation) => ({
          content: evaluation.rating ? evaluation.rating + '/' + evaluation.max_rating : '-',
          styles: { halign: 'left' }
        })),
        `${totalRating > 0 ? totalRating + '/' +totalMaxRating : '-'}`, // Total column showing sum of ratings
        `${ratingPercentage > 0 ? ratingPercentage + '%' : '-' }` // Percentage column showing percentage
      ];
    });
    
    doc.autoTable({
      head: [headRows],
      body: employeeDetails,
      startY: 45,
      margin: { top: 50, bottom: 20, left: 10, right: 10 },
      theme: 'plain',
      tableLineColor: '#3c4b64',
      tableLineWidth: 0.2,
      tableWidth: 280,
      styles: { lineColor: '#3c4b64', lineWidth: 0.2, halign: 'center' },
      headStyles: {
        fillColor: '#fff',
        textColor: [60, 75, 100],
        setFontSize: 8,
        font: 'helvetica',
      },
     
      didDrawPage: function (data) {
        //get page no
        totalPagesExp = doc.internal.getNumberOfPages()
        if (typeof doc.putTotalPages === 'function') {
          doc.putTotalPages(totalPagesExp)
        }
        let pageNo = doc.internal.getNumberOfPages()
        var pageSize = doc.internal.pageSize
        var pageHeight = pageSize.height ? pageSize.height : pageSize.getHeight()
        var pageWidth = pageSize.width ? pageSize.width : pageSize.getWidth() // Header

        doc.setTextColor('#3c4b64')
        doc.setFont('Helvetica', 'bold') //Header middle branch logo

        doc.addImage(logo, 'PNG', pageWidth - 280, 4, 25, 25)
        doc.line(pageWidth - 254, 7, pageWidth - 254, 27) // Adjust the coordinates as needed
        doc.setFontSize(11)
        doc.text('WAH', pageWidth - 251, 10, { align: 'left' })
        doc.setFont('Helvetica')
        doc.text('INDUSTRIES', pageWidth - 251, 15)
        doc.text('LIMITED', pageWidth - 251, 20)
        doc.setFontSize(9)
        doc.text('www.wahindustries.com', pageWidth - 251, 25)

        doc.setFontSize(14)
        doc.text('Performance Evaluation Summary Report', pageWidth - 20, 10, { align: 'right' }) // Add header separator

        yPosition -= -5 // Set alignment for the text that follows the line
        doc.setFont('Helvetica')
        doc.setFontSize(12)
        doc.setTextColor('#3c4b64')

        //Page No
        var str = "Page " + pageNo;
        // Total page number plugin only available in jspdf v1.0+
        if (typeof doc.putTotalPages === "function") {
          str = str + " of " + totalPagesExp;
        }

        doc.setTextColor("black");
        doc.text(str, 10, pageHeight - 4);
      },
    })

    doc.setFontSize(10)
    const printReport =
      'This Report is printed through ERP at ' + moment().format('YYYY-MM-DD HH:mm:ss')
    const styleReport = { halign: 'center' }
    const pageWidth = doc.internal.pageSize.width
    const textWidth =
      (doc.getStringUnitWidth(printReport) * doc.internal.getFontSize()) / doc.internal.scaleFactor
    const startXForPrintReport = (pageWidth - textWidth) / 2
    const startYForPrintReport = doc.autoTable.previous.finalY + 20

    doc.text(printReport, startXForPrintReport, startYForPrintReport, styleReport)

    const pdfBlob = doc.output('blob');
    const pdfUrl = URL.createObjectURL(pdfBlob);
    window.open(pdfUrl, '_blank');
  }
  
  const changeValues = (key, val) => {
    if (key === 'department_id') {
      setDepartmentId(val.value)
      setDepartmentName(val.label)
    }
    if (key === 'vehicle_id') {
      setVehicleId(val.value)
      setVehicleName(val.label)
    }
    if (key === 'designation_id') {
      setDesignationId(val.value)
      setDesignationName(val.label)
    }
    // if (key === 'employee_id') {
    //   setEmployeeId(val.value)
    //   setEmployeeName(val.label)
    // }
  }

  const getReportData = () => {
    if (range && range.length >= 2) {
      const fromDate = range[0];
      const toDate = range[1];
    setIsLoading(true)
    wtApiCall(
      'reports/vehicle_tracking_report',
      {
        from_date: fromDate.format('YYYY-MM-DD'),
        to_date: toDate.format('YYYY-MM-DD'),
        vehicle_id: VehicleId,
      },
      'get',
      (response) => {
        setReportData(response.data)
        setFromDate(response.from_date)
        setToDate(response.to_date)

        setIsLoading(false)
      },
      (error) => {
        lzNotifyErrorMessageFromResult(error)
        setIsLoading(false)
      },
    )
  } else {
    alert('Please select a valid date range.');

  }
  }
  const { onDownload } = useDownloadExcel({
    currentTableRef: tableRef.current,
    filename: 'Vehicle Tracking Report',
    sheet: 'Sheet',
  })

  useEffect(() => {
    Base.dropdownData(
      'vehicles',
      {},
      [ setVehicles],
      1,
    )
  }, [])
  return (
    <>
      <div style={{ padding: '2%' }}>
        <center>
          <h4>Vehicle Milage Report</h4>
        </center>
        <CRow style={{ width: '100%' }}>
          <CCol md={12}>
            <CCard className="card-dark">
              <CCardBody style={{ backgroundColor: '#f7f9fa' }}>
                <br />
                <CForm>
                  <CRow>
                    {/* <CCol md={1}></CCol> */}
                    <CCol md={1}>
                      <CInputGroup>
                        <label style={{ fontSize: '140%', marginTop: '50px' }}>Filters:</label>
                      </CInputGroup>
                    </CCol>
                    <CCol md={3}>
                      <div className="form-group">
                        <label>Date Range:</label>
                        <br />
                        <RangePicker value={range} onChange={setRange} size='middle' />
                      </div>
                    </CCol>
                    <CCol md={3}>
                    <CInputGroup>
                    <label>Vehicle No.</label>
                    <WidgetVehicleSelector
                      vehicles={Vehicles}
                      displayValue={VehicleName}
                      value={VehicleId}
                      placeholder="Select Vehicle No."
                      onChange={(values) => changeValues('vehicle_id', values)}
                      reloadDropdownData={() => Base.dropdownData('vehicles', {}, [setVehicles], 1)}
                      // viewOnly={props.viewOnly}
                    />
                    {errors.vehicle_id && <ErrorMessage messages={errors.vehicle_id} />}
                    </CInputGroup>
                    </CCol>
                    <CCol md={2}>
                      <CButton
                        color="primary"
                        onClick={() => getReportData()}
                        style={{ marginBottom: '20px', marginTop: '20px', marginLeft: '1%' }}
                      >
                        Search
                      </CButton>
                      {Base.hasRights('Export Vehicle Tracking Report') && (
               
                      <CButton
                        color="success"
                        className="text-white"
                        style={{ marginBottom: '20px', marginTop: '20px', marginLeft: '1%' }}
                        onClick={onDownload}
                      >
                        Export
                      </CButton>
                      )}
                         {/* <CButton
                          color="danger"
                          className="text-white"
                          style={{ marginBottom: '20px', marginTop: '20px', marginLeft: '1%' }}
                          onClick={generatePDF}
                        >
                          PDF
                        </CButton>  */}
                    </CCol>
                  </CRow>
                </CForm>
              </CCardBody>
            </CCard>
          </CCol>
        </CRow>
        <br />
        {/* <AttendanceReportLegends /> */}
        <CRow>
          <CCol md={12}>
            <table className="table table-bordered data-table" ref={tableRef}>
              {isLoading ? (
                Loading
              ) : (
                <>
                  {reportData.length > 0 ? (
                    <DataTable
                      reportData={reportData}
                      isLoading={isLoading}
                      FromDate={FromDate}
                      ToDate={ToDate}
                      ref={tableRef}
                    />
                  ) : (
                    <center style={{ fontSize: '19px', fontWeight: 'bold' }}>
                      No record to show...
                    </center>
                  )}
                </>
              )}
            </table>
          </CCol>
        </CRow>
      </div>
    </>
  )
}
